import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { useToasts } from 'react-toast-notifications';
import { addLoader, removeLoader } from '../../redux/slices/UserSlice';
import { IPFStoURL } from '../../helper/functions';
import { updateField } from '../../redux/slices/CollectionSlice';
import { DEFAULT_IMAGES } from '../../helper/constant';

const ImageUploader = ({ type }) => {
    const profile = useSelector((state) => state.collection.profile);
    const banner = useSelector((state) => state.collection.banner);
    const [file, setFile] = useState(null);
    const { addToast } = useToasts();
    const dispatch = useDispatch();


    const onDrop = async (acceptedFiles) => {
        try {
            dispatch(addLoader())
            const uploadedFile = acceptedFiles[0];
            setFile(uploadedFile);

            const formData = new FormData();
            formData.append('file', uploadedFile);

            const metadata = JSON.stringify({
                name: uploadedFile.name,
            });
            formData.append("pinataMetadata", metadata);

            const options = JSON.stringify({
                cidVersion: 0,
            });
            formData.append("pinataOptions", options);

            const res = await fetch(
                "https://api.pinata.cloud/pinning/pinFileToIPFS",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
                    },
                    body: formData,
                }
            );
            if (!res.ok) {
                dispatch(removeLoader())
                addToast('Failed to upload file.Please try again.', { appearance: 'error', });
            }
            const resData = await res.json();
            if (resData && resData.IpfsHash) {
                dispatch(removeLoader())
                type === 'banner' ?
                    dispatch(updateField({ field: 'banner', value: resData.IpfsHash })) :
                    dispatch(updateField({ field: 'profile', value: resData.IpfsHash }))

            }
        } catch (error) {
            dispatch(removeLoader())
            addToast(error.message, { appearance: 'error', });
            console.error('Error uploading file to IPFS:', error);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/svg+xml': [],
            'image/gif': []
        }
    });
    return (
        <div {...getRootProps()} className={`image-uploader ${type}-uploader`}>
            <input {...getInputProps()} />
            {file ? (
                <img src={URL.createObjectURL(file)} alt="Uploaded" className="uploaded-image img-fluid" />
            ) : (
                type === 'banner' ? (
                    <div class="d-create-file">
                        <p id="file_name">PNG, JPG, GIF or SVG, Max 10MB</p>
                        <img
                            src={banner ? IPFStoURL(banner) : IPFStoURL(DEFAULT_IMAGES.collection.banner)}
                            alt="banner"
                            height="100px"
                            width="100px"
                            className="default-image img-fluid"
                        />
                    </div>
                ) : (
                    <div class="d-create-file">
                        <p id="file_name">PNG, JPG, GIF or SVG, Max 10MB</p>
                        <img
                            src={profile ? IPFStoURL(profile) : IPFStoURL(DEFAULT_IMAGES.collection.profile)}
                            alt="banner"
                            height="100px"
                            width="100px"
                            className="default-image img-fluid"
                        />
                    </div>
                )
            )}
        </div >
    );
};

export default ImageUploader;
